import apiClient from '../../libs/apiClient'

export default {
  async getMe() {
    const result = await apiClient.get(`/me/user`)
    return result.data
  },
}
